export const COUNTRIES = {
  EGYPT: 'EGYPT',
  UAE: 'UAE',
  PAKISTAN: 'PAKISTAN',
  OMAN: 'OMAN',
  SAUDI_ARABIA: 'SAUDI_ARABIA',
} as const;

export const COUNTRY_TO_CODE = {
  [COUNTRIES.EGYPT]: 'egy',
  [COUNTRIES.UAE]: 'are',
  [COUNTRIES.PAKISTAN]: 'pak',
  [COUNTRIES.OMAN]: 'omn',
  [COUNTRIES.SAUDI_ARABIA]: 'sau',
} as const;

export const COUNTRY_TO_ISO_CODE = {
  [COUNTRIES.EGYPT]: 'EG',
  [COUNTRIES.UAE]: 'AE',
  [COUNTRIES.PAKISTAN]: 'PK',
  [COUNTRIES.OMAN]: 'OM',
  [COUNTRIES.SAUDI_ARABIA]: 'SA',
} as const;

export const CODE_TO_COUNTRY = Object.fromEntries(
  Object.entries(COUNTRY_TO_CODE).map(([country, code]) => [code, country])
);
